import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
// import { Messaging } from '@angular/fire/messaging';
import { environment } from '@environments/environment';
import { filter, take } from 'rxjs';
// import { Messaging } from '@angular/fire/messaging';
import { getMessaging, getToken } from '@angular/fire/messaging';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Messaging, onMessage } from '@angular/fire/messaging';
import type { MessagePayload } from 'firebase/messaging';
import { getAuth, getIdToken } from '@angular/fire/auth'; // firebase messaging
import { Auth, authState } from '@angular/fire/auth'; // firebase messaging
import { MatSnackBar } from '@angular/material/snack-bar';

// import { MessagingService } from '@app/services/messaging.service';
import {
  MatDrawerToggleResult,
  MatSidenav,
  MatSidenavModule,
} from '@angular/material/sidenav';
// import { CompanyService } from '@app/services/company.service';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import {} from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { GlobalSearchComponent } from '../../global-search/global-search.component';
import { LayoutService } from '../layout.service';
import { AsyncPipe } from '@angular/common';
import { OrganizationApi } from '@app/services/organization-api.service';
import { ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { Organizations } from '@app/interface/organizations';

@Component({
  selector: 'app-authorized-layout',
  templateUrl: './authorized-layout.component.html',
  styleUrls: ['./authorized-layout.component.scss'],
  imports: [
    RouterModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    SideMenuComponent,
    GlobalSearchComponent,
    // AsyncPipe,
  ],
  host: {
    class: 'h-100 app-layout app-layout-authorized',
  },
})
export class AuthorizedLayoutComponent implements OnInit {
  mobileMenuIsOpen = false;
  @ViewChild('mobileMenu') mobileMenu!: MatSidenav;

  // firebase
  private messaging = inject(Messaging);

  organization_data: Organizations | null = null;

  constructor(
    public layoutService: LayoutService,
    public organizationService: OrganizationApi,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private auth: Auth = inject(Auth),
  ) {} // private messagingService: MessagingService // private fireMessaging: AngularFireMessaging, // private angularFireMessaging: AngularFireMessaging, // private fireMessaging: Messaging // private afMessaging: AngularFireMessaging,

  // NOTE: this is no more useful since the image
  // is already replaced by the environment file replacement
  getLogoPath(): string {
    const source = this.organization_data?.source || 'BEIZY';

    // different logo for different organization sources
    if (source === 'CAF UIL Toscana') {
      return environment.logoImage;
    } else if (source === 'OTHER') {
      return environment.logoImage;
    } else {
      return environment.logoImage; // Default
    }
  }

  toggleMobileMenu() {
    // console.log('Toggling mobile menu.');
    if (this.mobileMenuIsOpen) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }

  openMobileMenu() {
    this.mobileMenu
      .open()
      .then((res: MatDrawerToggleResult) => {
        console.log('Mobile menu opened.', res);
        this.mobileMenuIsOpen = true;
      })
      .catch((err) => {
        console.error('Error occurred while opening mobile menu.', err);
      });
  }
  closeMobileMenu() {
    this.mobileMenu
      .close()
      .then((res: MatDrawerToggleResult) => {
        console.log('Mobile menu closed.', res);
        this.mobileMenuIsOpen = false;
      })
      .catch((err) => {
        console.error('Error occurred while opening mobile menu.', err);
      });
  }

  clickOnVoice() {
    this.closeMobileMenu();
  }

  // ngOnInit() {
  //   // this.fireMessaging.app. .getToken().then((currentToken) => {
  //   //   if (currentToken) {
  //   //     console.log('Got FCM token:', currentToken);
  //   //     // Send the token to your server and update the UI if necessary
  //   //   } else {
  //   //     console.log('No FCM token available. Request permission to generate one.');
  //   //     // Show permission request UI
  //   //   }
  //   // }
  //   // this.afMessaging.messaging.subscribe((messaging) => {
  //   //   messaging.onMessage((message) => {
  //   //     console.log('Message received:', message);
  //   //     // Handle the received message here
  //   //   });
  //   // });
  // }

  // requestPermission() {
  //   // this.afMessaging.requestPermission.subscribe(
  //   //   () => {
  //   //     console.log('Permission granted!');
  //   //     // Handle successful permission grant
  //   //   },
  //   //   (error) => {
  //   //     console.log('Permission denied:', error);
  //   //     // Handle permission denied or error
  //   //   }
  //   // );
  // }

  // message:any = null;

  ngOnInit(): void {
    this.getOrganization();

    // 2. Listen for the user to be logged in
    authState(this.auth)
      .pipe(
        filter((user) => !!user), // Only proceed if user is NOT null
        take(1), // We only need to do this once per session
      )
      .subscribe((user) => {
        // console.log('User identified, starting FCM setup...', user.uid);
        this.getMessagingToken();
        this.listen();
      });

    // console.log('this organization is:', this.organization_data);
    this.cdr.detectChanges();

    // this.requestPermission();
    // let requestPermissionSubject = this.messagingService.requestPermission();
    // requestPermissionSubject.subscribe({
    //   next: (permission) => {
    //     console.log('Permission!', permission);
    //     this.messagingService.requestForToken().then((token) => {
    //       console.log('A Token received.', token);
    //       console.log('A messagingService.requestForToken', token);
    //       this.messagingService
    //         .createDeviceToken({}, { token: token })
    //         .subscribe({
    //           next: (data) => {
    //             console.log(
    //               'A Device Token created or refreshed successfully.',
    //               data
    //             );
    //           },
    //           error: (error) => {
    //             console.error(
    //               'Error occurred while creating Device Token.',
    //               error
    //             );
    //           },
    //         });
    //       // return token;
    //     });
    //   },
    //   error: (error) => {
    //     console.error('Error occurred while requesting permission.', error);
    //   },
    // });
    // setTimeout(() => {
    // }, 3000);
    // this.listen();
  }

  extractOrganizationIdFromUrl(): number | null {
    const url = this.router.url;

    // Remove query parameters and hash if present
    const cleanUrl = url.split('?')[0].split('#')[0];

    // Match the first number in the URL path
    const match = cleanUrl.match(/^\/(\d+)/);

    if (match && match[1]) {
      const orgId = Number(match[1]);
      // console.log('Extracted organizationId:', orgId);
      return orgId;
    }

    console.warn('No numeric organization ID found at the start of URL');
    return null;
  }

  private getOrganization() {
    // Try to get organizationId from URL first
    let organization_id = this.extractOrganizationIdFromUrl();
    this.cdr.detectChanges();

    // If not found in URL, fall back to route params
    if (!organization_id) {
      organization_id = Number(
        this.route.snapshot.paramMap.get('organizationId'),
      );
      // console.log('OrganizationId from route params:', organization_id);
    }

    // If still not found, try alternative param names
    if (!organization_id || isNaN(organization_id)) {
      organization_id = Number(this.route.snapshot.paramMap.get('id'));
      // console.log('OrganizationId as "id":', organization_id);
    }

    if (organization_id && !isNaN(organization_id)) {
      const filterParams = {
        organization_id: organization_id,
      };

      this.organizationService
        .getOrganization<Organizations>(organization_id, filterParams)
        .subscribe({
          next: (organization_data: Organizations) => {
            // console.log('Organization:', organization_data);
            this.organization_data = organization_data;
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Error loading organization:', err);
            this.cdr.detectChanges();
          },
        });
    } else {
      console.error(
        'Could not extract valid organization ID from URL or route parameters',
      );
    }
  }

  // localStorage key used to avoid re-posting the same token/permission
  // state to the backend on every login/page load.
  private static readonly NOTIF_STATE_KEY = 'fcmNotificationState';

  async getMessagingToken() {
    // Guard for browsers/webviews that don't expose the Notification API at all
    // (e.g. some embedded webviews) - avoids a hard failure on getToken().
    if (typeof Notification === 'undefined') {
      console.warn(
        'Notification API not available in this environment; skipping FCM setup.',
      );
      return;
    }

    const previousState = this.readNotificationState();
    const currentPermission = Notification.permission;

    // Surface the case that actually indicates the underlying bug: the OS/
    // browser previously had this origin as 'granted' and it has now reverted
    // to 'default' (or 'denied') without the user explicitly revoking it here.
    if (
      previousState?.permission === 'granted' &&
      currentPermission !== 'granted'
    ) {
      console.warn(
        `Notification permission changed unexpectedly: was '${previousState.permission}', now '${currentPermission}'. ` +
          "This usually means the browser/OS cleared this app's site data (e.g. TWA cache clear), not an in-app action.",
      );
    }

    // Never call getToken() once the user has explicitly denied - Chrome won't
    // show the native prompt again anyway, and calling it just produces noise.
    if (currentPermission === 'denied') {
      this.writeNotificationState(
        currentPermission,
        previousState?.token ?? null,
      );
      return;
    }

    try {
      // Register (or reuse) the Firebase messaging service worker on its own
      // scope so it never competes with Angular's ngsw-worker.js for control
      // of the root scope - see authorized-layout investigation notes.
      const swRegistration = await navigator.serviceWorker.register(
        'firebase-messaging-sw.js',
        { scope: '/firebase-cloud-messaging-push-scope' },
      );

      const currentToken = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: swRegistration,
      });

      if (currentToken) {
        // Only hit the backend when permission or the token actually changed,
        // instead of unconditionally on every layout construction.
        if (
          previousState?.permission !== Notification.permission ||
          previousState?.token !== currentToken
        ) {
          this.saveTokenToBackend(currentToken);
        }
        this.writeNotificationState(Notification.permission, currentToken);
      }
    } catch (err) {
      console.error('Token retrieval failed', err);
    }
  }

  private readNotificationState(): {
    permission: NotificationPermission;
    token: string | null;
  } | null {
    try {
      const raw = localStorage.getItem(
        AuthorizedLayoutComponent.NOTIF_STATE_KEY,
      );
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  private writeNotificationState(
    permission: NotificationPermission,
    token: string | null,
  ) {
    try {
      localStorage.setItem(
        AuthorizedLayoutComponent.NOTIF_STATE_KEY,
        JSON.stringify({ permission, token }),
      );
    } catch {
      // ignore storage errors (e.g. private browsing)
    }
  }

  private async saveTokenToBackend(fcmToken: string) {
    // We can get the user directly from the Auth service now that we know they're logged in
    const user = this.auth.currentUser;

    if (user) {
      try {
        const idToken = await getIdToken(user);
        const headers = new HttpHeaders({
          Authorization: `Bearer ${idToken}`,
        });

        this.http
          .post(
            `${environment.backendDomain}/api/notifications/save-token/`,
            { token: fcmToken },
            { headers },
          )
          .subscribe({
            next: () => console.log('✅ Success! Device token saved.'),
            error: (err: any) => console.error('❌ Refused the token:', err),
          });
      } catch (err) {
        console.error('Error getting ID Token:', err);
      }
    }
  }

  // requestPermission() {
  //   this.fireMessaging
  //   // .then(
  //   //   {
  //   //     next: (app) => {
  //   //     },
  //   //   }
  //   // );

  //   const messaging = getMessaging();
  //   getToken(messaging,
  //    { vapidKey: environment.firebase.vapidKey}).then(
  //      (currentToken) => {
  //        if (currentToken) {
  //          console.log("Hurraaa!!! we got the token.....");
  //          console.log(currentToken);
  //        } else {
  //          console.log('No registration token available. Request permission to generate one.');
  //        }
  //    }).catch((err) => {
  //       console.log('An error occurred while retrieving token. ', err);
  //   });
  // }
  // listen() {
  //   // const messaging = getMessaging();
  //   // onMessage(messaging, (payload) => {
  //   //   console.log('Message received. ', payload);
  //   //   // this.message=payload;
  //   // });
  // }
  listen() {
    // FCM's onMessage() only fires while this tab is focused, and unlike a
    // background push (handled by the service worker's onBackgroundMessage,
    // see firebase-messaging-sw.js) it does NOT show a native browser
    // notification - Firebase leaves that entirely up to the app. Until this
    // was wired up, the payload was only ever console.logged: a user with
    // the app open (e.g. mid-session while the commercialista answers a
    // ticket) got no visible feedback at all and had to reload to notice.
    onMessage(this.messaging, (payload) => {
      this.showForegroundNotification(payload);
    });
  }

  private showForegroundNotification(payload: MessagePayload): void {
    const data = (payload.data || {}) as Record<string, string>;
    const title = data['title'] || 'Nuova notifica';
    const body = data['body'];

    const snackBarRef = this.snackBar.open(body ? `${title} — ${body}` : title, 'Apri', {
      duration: 6000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });

    snackBarRef.onAction().subscribe(() => this.goToNotificationTarget(data));

    // The unread badges in the side menu ("Notifiche e avvisi" / "Il tuo
    // Commercialista") only refresh on ngOnInit/navigation, so without this
    // they'd stay stale for as long as the tab remains open after a push.
    this.layoutService.notifyNewNotification();
  }

  private goToNotificationTarget(data: Record<string, string>): void {
    const organizationId =
      this.organization_data?.id || this.extractOrganizationIdFromUrl();

    if (!organizationId) {
      return;
    }

    // Mirrors the message_id/organization_id/notification_type fields added
    // server-side in core/models.py (send_push_on_new_message /
    // send_push_on_new_ticket_response) - only used today to route to the
    // right section; opening the specific message/ticket is a follow-up.
    const path =
      data['notification_type'] === 'ticket'
        ? 'commercialista-tickets'
        : 'inbox';

    this.router.navigate([`/${organizationId}/${path}`]);
  }

  backToHome(): void {
    // const org_id = this.route.snapshot.paramMap.get('organizationId');
    const org_id = this.organization_data?.id;
    this.router.navigate([`/${org_id}/dashboard`]);
  }
}

// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-autorized-layout',
//   standalone: true,
//   imports: [],
// })

// }

// styleUrl: './autorized-layout.component.scss'
// templateUrl: './autorized-layout.component.html',
// export class AutorizedLayoutComponent {
